import { stat } from 'fs';
import { USER_RIGHTS_SET, USER_RIGHTS_EDITED, USER_RIGHTS_ADDED } from 'src/app/redux/redux-types';
import { reduxUserRightsTypes } from 'src/types';

export const userRightsDefaultState: reduxUserRightsTypes.StateType = {
  userRights: [],
};

export const userRightsReducer = (
  state = userRightsDefaultState,
  action: reduxUserRightsTypes.ActionType,
): reduxUserRightsTypes.StateType => {
  switch (action.type) {
    case USER_RIGHTS_SET:
      return {
        ...state,
        userRights: action.payload,
      };
    case USER_RIGHTS_ADDED:
      return {
        ...state,
        userRights: [...state.userRights, action.payload],
      };
    case USER_RIGHTS_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.userRights.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        userRights: [
          ...state.userRights.slice(0, updateIndex),
          action.payload,
          ...state.userRights.slice(updateIndex + 1),
        ],
      };
    default:
      return state;
  }
};

// export const userRightsDefaultState: reduxUserRightsTypes.StateType = {
//   id: undefined,
//   formType: undefined,
//   userRoleId: undefined,
//   create: false,
//   edit: false,
//   read: false,
//   delete: false,
// };

// export const userRightsReducer = (
//   state = userRightsDefaultState,
//   action: reduxUserRightsTypes.ActionType,
// ): reduxUserRightsTypes.StateType => {
//   switch (action.type) {
//     case USER_RIGHTS_SET:
//       return {
//         ...state,
//         id: action.payload.id,
//         formType: action.payload.formType,
//         userRoleId: action.payload.userRoleId,
//         create: action.payload.create,
//         edit: action.payload.edit,
//         read: action.payload.read,
//         delete: action.payload.delete,
//       };
//     default:
//       return state;
//   }
// };
